import css from 'styled-jsx/css';

export default css`
  .ImageSlider {
    display: grid;
    grid-template-areas:
      'image'
      'caption';
    grid-template-rows: auto max-content;
    margin-bottom: 1rem;
  }
  .ImageSlider__TriangleHint .amp-image-slider-hint-left {
    width: 10px;
    height: 20px;
    background-size: 10px 20px;
    margin-right: 10px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 10 20'%3e%3cpolygon points='10,0 0,10 10,20' style='fill:white' /%3e%3c/svg%3e");
  }
  .ImageSlider__TriangleHint .amp-image-slider-hint-right {
    width: 10px;
    height: 20px;
    background-size: 10px 20px;
    margin-left: 10px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 10 20'%3e%3cpolygon points='0,0 10,10 0,20' style='fill:white' /%3e%3c/svg%3e");
  }
  .ImageSlider amp-img {
    grid-area: image;
  }
  .ImageSlider :global(.ImageCaption) {
    grid-area: caption;
    margin-top: 0.25rem;
  }
  .ImageSlider__info {
    display: flex;
    justify-content: space-between;
    margin-top: 0.25rem;
  }
  .PrismEntryButton--text {
    display: flex;
  }
`;
